import { Trans } from 'react-i18next';
import { Link } from '../../../../../../../shared/frontend/components/link';
import { asset } from '../../../../../../../shared/frontend/services/assetResolverService';
import cx from 'classnames';
import { t } from 'i18next';

export type TSiteDescriptionProps = {
  enabled: boolean;
  expansion: string;
  seasonSlug: string;
  raidSlug: string;
  className?: string;
};

export function SiteDescription(props: TSiteDescriptionProps) {
  if (!props.enabled) {
    return null;
  }

  return (
    <div className={cx('slds-grid slds-grid--pull-padded align-justify', props.className)}>
      <div className="slds-col slds-shrink-none slds-align--absolute-center slds-grow-none slds-p-horizontal--small rio-hidden--small">
        <img
          src={asset('/images/brand/Icon_FullColor_Square.png', {
            width: 200
          })}
          style={{ width: 100, height: 100 }}
        />
      </div>
      <h1 className="slds-col slds-p-horizontal--small slds-text-body--large">
        <Trans
          i18nKey="frontpage:description"
          values={{
            expansion: t(`common:expansions.${props.expansion}.name`),
            season: t(`seasons:${props.seasonSlug}.base-name`),
            raid: t(`raids:${props.raidSlug}.name`)
          }}
        >
          <Link to="/mythic-plus" />
          <Link to="/raids" />
          <Link to="/recruitment" />
          <Link to="/discord" />
          <Link to="/rwf" />
          <Link to="/addon" />
        </Trans>
      </h1>
    </div>
  );
}
